(function () {
    'use strict';

    angular
        .module('procedureModule')
        .controller('BusinessUnitModalController', Controller);

    Controller.$inject = ['$scope', 'businessUnitService'];

    function Controller($scope, businessUnitService) {
        $scope.ctxSelection = {
            searchTerm: null
        };

        $scope.searchBusinessUnit = function (searchTerm) {
            if (_.isUndefined(searchTerm) || searchTerm.length < 2) {
                $scope.availableBusinessUnits = [];
                return;
            }
            businessUnitService
                .searchBusinessUnit(searchTerm)
                .then(function (foundBusinessUnits) {
                    $scope.availableBusinessUnits = foundBusinessUnits;
                });
        };
    }
})();